module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/5_f2857a372d596b093dc5136d23c13d95.png";